export var illustrationComponentName = 'QuantumIllustration';
